import _default from './Tab';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/semantic-ui-react/dist/es/modules/Tab/index.js
// module id = 905
// module chunks = 0